import { mapActions } from "vuex";
import { GET_ALL_BROKER_PROMOTION, EDIT_BROKER_PROMOTION} from '@/store/actions.type'
import addPromo from '../../components/AddPromo.vue'
import { param } from "jquery";
// import moment from 'moment'
// import { param } from "jquery";
// import { data } from "jquery";
export default {
    data() {
        return {
            currentPage: 1,
            elementsPerPage: 20,
            ascending: false,
            sortColumn: '',
            promoList: [],
            promoColumns: ['SNo', 'Promo', 'Description', 'Percentage', 'IsActive', 'StartDate', 'EndDate', 'UsageLimit', 'Action'],
            showDailogToAddNewPromo: false,
            selectedPromoData: {},
            isNewPromocode: false
        }
    },

    components: { addPromo },

    created() {
        this.fetchAllPromo();
    },

    computed: {
        getUserDetails() {
            return this.$store.state.authentication.user;
      }
    },


    methods: {
        ...mapActions({
          getallbrokerpromo: GET_ALL_BROKER_PROMOTION,
          editbrokerpromotion: EDIT_BROKER_PROMOTION
        }),

 

        async fetchAllPromo() {
            let param = {
                "userType" : 2 //@TO-DO this.userDetails.userType
            }

            await this.getallbrokerpromo().then(data => {
                if (data != null || data.length >0) {
                    this.promoList = data
                }
                else{
                    alert("No Promo available")
                }
            })
        },

        async editPromocode(selectedCol) {
            if (this.currentPage > 1) {
                selectedCol = this.elementsPerPage + selectedCol
            }
            this.isNewPromocode = false
            const getSelectedId = this.promoList[selectedCol].id
            this.fetchSelectedPromo(getSelectedId)
        },

        async fetchSelectedPromo(selectedId) {
            let params = {
                "promotionId": selectedId,
                "userType": this.getUserDetails.userType
            }

            await this.editbrokerpromotion(params).then(data => {
                if (data != null) {
                    this.selectedPromoData = data
                    this.showDailogToAddNewPromo = true
                }
                else{
                    alert("Something went wrong")
                }
            })
        },

        async addPromocode() {
            this.isNewPromocode = true
            this.selectedPromoData = {}
            this.showDailogToAddNewPromo = true
        },

        sortTable: function sortTable(col) {
            if (this.sortColumn === col) {
                this.ascending = !this.ascending;
            } else {
                this.ascending = true;
                this.sortColumn = col;
            }

            var ascending = this.ascending;

            this.promoList.sort(function (a, b) {
                if (a[col] > b[col]) {
                    return ascending ? 1 : -1
                } else if (a[col] < b[col]) {
                    return ascending ? -1 : 1
                }
                return 0;
            })
        },
       
        get_rows_forPromoList: function get_rows_forPromoList() {
            var start = (this.currentPage - 1) * this.elementsPerPage;
            var end = start + this.elementsPerPage;
            return this.promoList.slice(start, end);
        },
        change_page: function change_page(page) {
            this.currentPage = page;
        },

        cancelModal (action) {
            this.showDailogToAddNewPromo = false;
            if (action == 1) {
                this.fetchAllPromo();
            }
          },


    }
}


// WEBPACK FOOTER //
// ./src/assets/js/PartnerBrokerPromoCode.js